export default "__VITE_ASSET__CDabWXPR__"